import * as React from 'react';
import { Icon, Button, NestedTable } from 'react-inv-forms';
import { withTranslation, WithTranslation } from 'react-i18next';
import fingerprint from '../../../images/fingerprint.svg';
import changeLog from '../../../images/changeLog.svg';
import { DetailsContainer, ButtonsContainer, NavButtonsBox } from './StudentDetailsView.style';
import { StudentData } from '../../../redux/marks/types';
import { Tooltip } from 'antd';
import { FlexBox } from '../../../styles/tabContainers';
import ColumnsAdapter from '../../../helpers/columnsAdapter';
import { DownCircleFilled, UpCircleOutlined } from '@ant-design/icons';
import columnsAdapter from '../../../helpers/columnsAdapter';

export interface Props extends WithTranslation {
  /** kolumny tabeli */
  columns: SingleColumn[];
  /** kolumny tabeli z ocenami */
  marksColumns: SingleColumn[];
  /** dane do tabeli */
  data: SingleObjectDataStructure[];
  /** dane do tabeli z ocenami */
  marksData: SingleObjectDataStructure[];
  /** translacje dla  przycisków */
  translations: { [key: string]: React.ReactElement };
  /** callback wykonywany po kliknięciu na przycisk "Historia Ocen" */
  onChangeLogCheck: () => void;
  /** callback wykonywany po kliknięciu na przycisk "Podpisz oceny" */
  openSignModal: (list: StudentData[]) => void;
  /** dane o ocenach */
  marks: any;
  /** informacja, czy użytkownik posiada uprawnienia do wystawienia oceny */
  czyKierownik: boolean;
  /** callback wykonywany po kliknięciu na przycisk "Następny" */
  goToNextStudent: () => void;
  /** informacja, czy przycisk "Następny" powinien być dezaktywowany */
  nextDisabled: boolean;
  /** callback wykonywany po kliknięciu na przycisk "Poprzedni" */
  goToPrevStudent: () => void;
  /** informacja, czy przycisk "Poprzedni" powinien być dezaktywowany */
  prevDisabled: boolean;
}

const addTableKey = (array: object[]): object[] => array.map((item, idx) => ({ ...item, key: idx }));

/**
 *  Komponent widoku szczegółowego studenta
 *  Wyświetla tabelę z informacjami dodatkowymi oraz tabelę z ocenami cząstkowymi, końcową i wyliczoną
 *  umożliwia dostęp do przycisków służących poglądowi historii ocen oraz przejścia do procesu podpisania ocen
 *  zawiera przyciski "Poprzedni" i "Następny"
 *
 */
export class StudentDetailsView extends React.Component<Props> {
  componentDidMount(): void {
    window.addEventListener('keydown', this.handleKeyDown);
  }
  componentWillUnmount(): void {
    window.removeEventListener('keydown', this.handleKeyDown);
  }
  generateStudentMarkData = () => {
    const { studentImie, studentNazwisko, studentAlbum, ocenaKoncowaDataTimestamp, studentWydzial, studentId } =
      this.props.data[0];
    return {
      firstName: studentImie,
      lastName: studentNazwisko,
      albumId: studentAlbum,
      ocena: this.props.marks && this.props.marks.ocenaKoncowa ? this.props.marks.ocenaKoncowa : '',
      obligatoryjnaDataWystawienia: ocenaKoncowaDataTimestamp,
      studentWydzial: studentWydzial,
      studentId,
    };
  };
  handleKeyDown = (e: any): void => {
    if (e.key.toLowerCase() === 'arrowdown') {
      this.props.goToNextStudent();
    } else if (e.key.toLowerCase() === 'arrowup') {
      this.props.goToPrevStudent();
    }
  };
  render(): React.ReactElement {
    const { translations } = this.props;
    const { studentId, studentZdjecie } = this.props.data[0];
    return (
      <DetailsContainer>
        <NavButtonsBox>
          <Tooltip title={this.props.t('BUTTON_PREV')}>
            <Button
              iconButton
              icon={<UpCircleOutlined />}
              noPadding
              id={`btn_prev_${studentId}`}
              disabled={this.props.prevDisabled}
              onClick={this.props.goToPrevStudent}
              className='move_btn'
              tabIndex={2}
              outlined={true}
              onKeyDown={this.handleKeyDown}
            />
          </Tooltip>
          <Tooltip title={this.props.t('BUTTON_NEXT')}>
            <Button
              iconButton
              icon={<DownCircleFilled />}
              noPadding
              id={`btn_next_${studentId}`}
              disabled={this.props.nextDisabled}
              tabIndex={1}
              onClick={this.props.goToNextStudent}
              className='move_btn'
              outlined={true}
              onKeyDown={this.handleKeyDown}
            />
          </Tooltip>
        </NavButtonsBox>
        <div>
          <ButtonsContainer>
            <Button outlined={true} onClick={this.props.onChangeLogCheck} data-cy='btnChangeLog'>
              <Icon path={changeLog} />
              {translations.changeLog}
            </Button>
            <Button
              disabled={!this.props.czyKierownik}
              onClick={this.props.openSignModal.bind(null, [this.generateStudentMarkData()])}
              data-cy='btnSignFinalMark'
            >
              <Icon path={fingerprint} />
              {translations.signMarks}
            </Button>
          </ButtonsContainer>
          <FlexBox justify='flex-start'>
            {studentZdjecie}
            <div>
              <NestedTable
                className='nested'
                columns={columnsAdapter.removeUnwantedColumns(ColumnsAdapter.removeSorter(this.props.columns), [
                  'studentZdjecie',
                ])}
                dataSource={addTableKey(this.props.data)}
                pagination={false}
              />
              <NestedTable
                className='table__marks nested'
                columns={ColumnsAdapter.removeSorter(this.props.marksColumns)}
                dataSource={addTableKey(this.props.marksData)}
                pagination={false}
              />
            </div>
          </FlexBox>
        </div>
      </DetailsContainer>
    );
  }
}

export default withTranslation()(StudentDetailsView);
